import { render, staticRenderFns } from "./Imagebutton.vue?vue&type=template&id=cbf66940&scoped=true&"
import script from "./Imagebutton.vue?vue&type=script&lang=js&"
export * from "./Imagebutton.vue?vue&type=script&lang=js&"
import style0 from "./Imagebutton.vue?vue&type=style&index=0&id=cbf66940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf66940",
  null
  
)

export default component.exports